import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import '../../stylesheets/household.scss';
import { Button, InputField } from '@unite-us/ui';
import { compareCountTotals } from '../../utils';
import { Form, Field } from 'react-final-form';
import { isEmpty, first } from 'lodash';
import { callbacks, getAdapter, trackEvent } from '../../../../../config/api';
import { composeValidators } from '../../../../utils/composeValidators';
import callOrLog from '../../../../../constants/callOrLog';
import { FACESHEET } from '../../../../../constants/eventConstants';
var sanitizedData = function sanitizedData(data) {
  return data === '' ? 0 : data;
};
export function HouseholdCountForm(props) {
  var contact = props.contact;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var sanitizedHouseholdCount;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            sanitizedHouseholdCount = {
              total: sanitizedData(data.total),
              adults: sanitizedData(data.adults),
              children: sanitizedData(data.children)
            };
            _context.next = 3;
            return getAdapter('coreApi').updateRecord("person", contact.id, {
              household: sanitizedHouseholdCount
            });
          case 3:
            callOrLog(function () {
              return trackEvent(FACESHEET.householdSizeUpdated, {
                contact_id: contact.id
              });
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var formValidator = {
    countTotalsValidator: function countTotalsValidator(_, household) {
      var errors = {};
      errors.count_incorrect = compareCountTotals(household);
      if (errors.count_incorrect !== null) {
        setFormErrors(errors.count_incorrect);
      }
      return errors.count_incorrect;
    },
    totalCountValidator: function totalCountValidator(values) {
      var errors = {};
      if (values <= 0) {
        errors.total_count = 'Total count can not be less than 1';
        setFormErrors(errors.total_count);
        return errors.total_count;
      }
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: contact.household,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting;
      return /*#__PURE__*/React.createElement("form", {
        className: "household-count-form content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "household-count-inputs"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8"
      }, /*#__PURE__*/React.createElement("div", {
        className: "household-count-inputs__total-count"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "total",
        validate: composeValidators(formValidator.countTotalsValidator, formValidator.totalCountValidator)
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          className: "household-input-field",
          id: "household.total",
          label: "Total Count",
          type: "number",
          inline: false,
          inputStyle: {
            width: '30%'
          },
          min: 1
        }, params));
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("p", {
        className: "household-count-inputs__optional-label sub-header italicize-text"
      }, "Optional")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "adults"
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          className: "household-input-field",
          id: "household.adults",
          label: "# adults",
          type: "number",
          inline: false,
          inputStyle: {
            width: '50%'
          },
          min: 0
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "children"
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          className: "household-input-field",
          id: "children",
          label: "# children",
          type: "number",
          inline: false,
          inputStyle: {
            width: '50%'
          },
          min: 0
        }, params));
      })))), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-citizen-cancel-btn",
        onClick: props.closeModal,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-citizen-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        onClick: function onClick() {
          if (!isEmpty(formErrors)) {
            setTimeout(function () {
              var _focusableErr;
              var focusableErr;
              var err = first(document.getElementsByClassName('ui-form-field--has-error'));
              if (err) {
                focusableErr = first(err === null || err === void 0 ? void 0 : err.getElementsByTagName('input'));
              }
              if (focusableErr) {
                focusableErr.ariaLabel = formErrors;
              }
              (_focusableErr = focusableErr) === null || _focusableErr === void 0 || _focusableErr.focus();
              setFormErrors({});
            }, 300);
          } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
            var editHouseholdCountModal = document.getElementById('edit-household-count-modal');
            var errInModal = first(editHouseholdCountModal === null || editHouseholdCountModal === void 0 ? void 0 : editHouseholdCountModal.getElementsByClassName('ui-form-field--has-error'));
            var focusableErr = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
            focusableErr === null || focusableErr === void 0 || focusableErr.focus();
          }
          handleSubmit();
        }
      }))));
    }
  });
}
HouseholdCountForm.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired
};
export default HouseholdCountForm;
//# sourceMappingURL=HouseholdCountForm.js.map